import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutReverseOfficeCheck extends Layout {
    buttonReverseChecks: Button;
    horizontalspacer1: HorizontalSpacer;
    labelCheckDateTo: Label;
    labelCheckNumberTo: Label;
    panelProcessLog: Panel;
    panelSearchFields: Panel;
    searchpanelReverseOfficeCheck: SearchPanel;
    sourceNonVoidedOffChecks: DataSource;
    tableChecks: Table;
    textboxBankAccountIdSearch: Textbox;
    textboxCheckDateFrom: Textbox;
    textboxCheckDateTo: Textbox;
    textboxCheckNumberFrom: Textbox;
    textboxCheckNumberTo: Textbox;
    textboxPayeeIdSearch: Textbox;
    textboxVoidDate: Textbox;
}
